// src/components/Register.jsx
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../../Firebase'; 
import React from 'react';
import { doc, setDoc, getFirestore } from 'firebase/firestore';
import './register.css';

export default function Register() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const db = getFirestore();

  const handleRegister = async (e) => {
    e.preventDefault();
    setError('');

      try {
        // Create user with Firebase Auth
        const userCredential = await createUserWithEmailAndPassword(auth, email, password);
        const user = userCredential.user;
  
        // Set role in Firestore (default to "user" role)
        await setDoc(doc(db, 'users', user.uid), {
          role: 'user',  // Set default role as 'user'
        });
  
        navigate('/');  // Redirect to login after registration
      } catch (err) {
        setError(err.message);  // Display Firebase error messages
      }
    };
  

  return (

    <div className="login-background">
    <div className="hibiscus hibiscus-1"></div>
      <div className="hibiscus hibiscus-2"></div>
      <div className="butterfly butterfly-1"></div>
      <div className="butterfly butterfly-2"></div>
      <div className="butterfly butterfly-3"></div>
      <img className="hibiscusimg" src="https://cdn-icons-png.flaticon.com/512/8174/8174547.png" alt="hibiscus" />

    <div className="register-container">
      <h1 className='login-h1'>Register</h1>
      <form onSubmit={handleRegister}>
        <input
        className='login-input'
          type="email"
          placeholder="Email"
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <input
        className='login-input'
          type="password"
          placeholder="Password"
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <button type="submit" className='login-btn'>Register</button>
        {error && <p style={{ color: 'red' }}>{error}</p>}
      </form>
      <p className='p-login'>Already have an account? <a href="/" className='a-login'>Login</a></p>
    </div>
    </div>
  );
}
